import messages from './messages';
import { LabelFormat } from '../../../../../components/layout-selector/contants';

export const PackingSlipFormat = {
  FourBySix: '4x6',
  HalfLetter: 'HalfLetter',
  Letter: 'Letter',
  AFour: 'A4',
  ASix: 'A6',
};

export const defaultPackingSlipFormats = [
  {
    value: PackingSlipFormat.FourBySix,
    messageDescriptor: messages.packingSlip4x6,
  },
  {
    value: PackingSlipFormat.HalfLetter,
    messageDescriptor: messages.packingSlipHalfLetter,
  },
  {
    value: PackingSlipFormat.Letter,
    messageDescriptor: messages.packingSlipLetter,
  },
];

// TODO: [SPD-19601]: Combine this with previous constant "defaultPackingSlipFormats" when feature flag is removed
export const newPackingSlipFormats = [
  {
    value: PackingSlipFormat.AFour,
    messageDescriptor: messages.packingSlipAFour,
  },
  {
    value: PackingSlipFormat.ASix,
    messageDescriptor: messages.packingSlipASix,
  },
];

export const defaultPackingSlipFormat = defaultPackingSlipFormats[0];

export const packingSlipFormatsFromLabel = [
  {
    value: LabelFormat.FourBySixWithPackingSlip,
    messageDescriptor: messages.packingSlip4x6,
  },
  {
    value: LabelFormat.LetterWithPackingSlip,
    messageDescriptor: messages.packingSlipLetter,
  },
];

// TODO: [SPD-19601]: Combine this with previous constant "defaultPackingSlipFormats" when feature flag is removed
export const newPackingSlipFormatsFromLabel = [
  {
    value: LabelFormat.AFourWithPackingSlip,
    messageDescriptor: messages.packingSlipAFour,
  },
  {
    value: LabelFormat.ASixWithPackingSlip,
    messageDescriptor: messages.packingSlipASix,
  },
];

export const packingSlipSortings = [
  {
    messageDescriptor: messages.sku,
    value: 'SKU asc',
  },
  {
    messageDescriptor: messages.name,
    value: 'Description asc',
  },
  {
    messageDescriptor: messages.itemLowToHigh,
    value: 'Quantity asc',
  },
  {
    messageDescriptor: messages.itemHighToLow,
    value: 'Quantity desc',
  },
  {
    messageDescriptor: messages.warehouseLocation,
    value: 'WarehouseLocation asc',
  },
  {
    messageDescriptor: messages.none,
    value: 'OrderItemID asc',
  },
];

export const INCLUDES_PACKING_SLIP_SUFFIX = '-i';
